import React , { useState, useEffect, useRef } from 'react';
import { v4 as GUID } from 'uuid';
import { makeStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grid from '@material-ui/core/Grid';
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        margin: '15px 0px 15px 0px',
        borderRadius: '8px',
    },
    expand: {
        border: "1.5px solid #4c6386",
        borderRadius: 15,
        color: "#4c6386",
        transform: 'rotate(180deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(0deg)',
    },
    avatar: {
        backgroundColor: red[500],
    },
    mainTitle: {
        fontSize: "1rem",
    },
    italicTitle: {
        display: 'inline',
        marginLeft: '15px',
        fontSize: '12px'
    }
}));


export default function PanelExpand({ title, style={}, titleStyle, moreElement, gridProps={}, gridTitleProps={}, gridMoreElementProps={},panelPanelDetailProps={}, children, italicTitleEnd, italicTitleEndStyle, expand ,disabled, onExpand, divStyle={},expansionPanelStyle={}}) {
    const [expanded, setExpanded] = React.useState( expand !== undefined && expand !== null ? expand : true);

    const handleExpandClick = () => {
        const _temp = !expanded;
        setExpanded(_temp);
        
        if(onExpand)
        {
            onExpand(_temp)
        }
    };
    const classes = useStyles();
    const panelID = 'exPanel-' + GUID();

    useEffect(() => {
        if(disabled === true){
            setExpanded(false);
        }}
    );
    
    return (
        <div style={{...divStyle}}>
            <Card style={{...style}} >
                <Accordion expanded={expanded} disabled={disabled?disabled:false} style={{...expansionPanelStyle}}>
                    <Grid container {...gridProps} style={{ backgroundColor: '#0072bc', color: "#FFFFFF"}}>
                        <Grid item {...gridTitleProps}>
                            <AccordionSummary
                                aria-expanded={expanded}
                                onClick={handleExpandClick}
                                aria-controls={panelID}
                                style={{color: "#FFFFFF"}}
                            >
                                <ExpandMoreIcon style={{color: "#FFFFFF", border: "1.5px solid #ffffff"}} className={clsx(classes.expand, {
                                    [classes.expandOpen]: expanded,
                                })} />
                                <Typography
                                    component="h5"
                                    variant="h5"
                                    style={{
                                        paddingLeft: 10,
                                        lineHeight: "23px",
                                        ...titleStyle,
                                        color: "#FFFFFF"
                                    }}
                                    className={clsx(classes.mainTitle)}
                                >
                                    {title}<i className={clsx(classes.italicTitle, italicTitleEndStyle)}>{italicTitleEnd}</i>
                                </Typography>
                            </AccordionSummary>
                        </Grid>
                        <Grid item style={{display:moreElement === null ?'none':''}} {...gridMoreElementProps}>
                            {moreElement}
                        </Grid>
                    </Grid>
                    <AccordionDetails {...panelPanelDetailProps}>
                        {children}
                    </AccordionDetails>
                </Accordion>

            </Card>
        </div>
    )
}